import { useSearchParams } from '@occc-app/hooks/useSearchParams';

import { LocationGroupTab } from './types';

export const BEFORE_PARAM_NAME = 'group-before';
export const AFTER_PARAM_NAME = 'group-after';

const LOCATIONS_PREFIX = 'locations';
const ISSUES_PREFIX = 'issues';

export const LOCATIONS_BEFORE_PARAM = `${LOCATIONS_PREFIX}-before`;
export const LOCATIONS_AFTER_PARAM = `${LOCATIONS_PREFIX}-after`;

export const LOCATIONS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${LOCATIONS_PREFIX}-search`,
  afterParamName: LOCATIONS_AFTER_PARAM,
  beforeParamName: LOCATIONS_BEFORE_PARAM,
};

export const ISSUES_BEFORE_PARAM = `${ISSUES_PREFIX}-before`;
export const ISSUES_AFTER_PARAM = `${ISSUES_PREFIX}-after`;

export const ISSUES_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${ISSUES_PREFIX}-search`,
  afterParamName: ISSUES_AFTER_PARAM,
  beforeParamName: ISSUES_BEFORE_PARAM,
};

export const LOCATION_GROUP_TAB_PARAM = 'tab';
export const DEFAULT_LOCATION_GROUP_TAB: LocationGroupTab = 'locations';
export const LOCATION_GROUP_TABS: LocationGroupTab[] = ['locations', 'issues'];
